require('../../modules/es.array.includes');

module.exports = require('../../internals/entry-unbind')('Array', 'includes');
